<certification-display-list-item-slimmable *ngFor="let certification of learnerCertifications"
[slimMode]="slimMode"
[certification]="certification"
></certification-display-list-item-slimmable>
